import { Button } from "antd";
import Image from "next/image";
import React from "react";
import { MICROSOFT_TEAMS_LINK } from "@buddieshr/utils/constants";
import { useTranslation } from "react-i18next";
import styles from '@buddieshr/styles/billy/billyForTeams.module.scss'

const BillyForTeams = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.BillyTeams_wrapper}>
      <div className={styles.BillyTeams_inner}>
        <div className={styles.BillyTeams_picture}>
          <Image
            src="/img/microsoft-teams-logo.png"
            alt="microsoft teams birthday employee"
            width={144}
            height={38}
          />
        </div>
        <h2 className={styles.BillyTeams_title}>{t("billyBotForTeams")}</h2>
        <div className={styles.BillyTeams_subtitle}>{t("tryOutforFree")}</div>
        <div className={styles.BillyTeams_action}>
          <a
            href={MICROSOFT_TEAMS_LINK}
            title={t("celebrateBdayOnTeams")}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button size="large" type="primary" style={{ margin: "auto" }}>
              {t("getStarted")}
            </Button>
          </a>
        </div>
        <div className={styles.BillyTeams_hint}>{t("noCreditCardNothing")}</div>
      </div>
    </div>
  );
};

export default BillyForTeams;
